import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Validators from '../../utils/Validators';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import { addServicer, updateServicer } from '../../actions/dataActions';
import ServicersApi from '../../api/servicers';

class Servicer extends Component {
  state = {
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    email: '',
    fax: '',
    busy: false,
    loading: false
  };

  componentDidMount() {
    if (this.props.mode === 'edit') {
      this.setState(
        {
          loading: true
        },
        () =>
          ServicersApi.get(this.props.servicer)
            .then(
              data => {
                this.setState({
                  loading: false,
                  ...data
                });
              },
              error => {
                this.props.showError();
                this.props.onCancel();
              }
            )
            .catch(error => {
              this.props.showError();
              this.props.onCancel();
            })
      );
    }
  }

  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  save = () => {
    if (
      !this.state.name ||
      !this.state.address1 ||
      !this.state.city ||
      !this.state.zip
    )
      this.props.showError('You must enter the address of the Servicer.');
    else if (!/^[A-Z]{2}$/.test(this.state.state))
      this.props.showError('The State must have only two capital letters.');
    else if (!Validators.isValidPhone(this.state.phone))
      this.props.showError('Please enter a valid phone number');
    else if (!Validators.isValidEmail(this.state.email))
      this.props.showError('Please enter a valid Email Address');
    else if (!this.state.fax)
      this.props.showError('You must enter the Fax number of the Servicer.');
    else {
      this.setState({ busy: true }, () => {
        if (this.props.mode === 'edit') {
          ServicersApi.update(this.props.servicer, this.state)
            .then(
              servicer => {
                this.props.onUpdated(servicer);
                this.props.showMessage(
                  'The servicer information has been updated successfully.'
                );
                this.props.onCancel();
              },
              error => {
                this.setState({ busy: false }, this.props.showError);
              }
            )
            .catch(error => {
              this.setState({ busy: false }, this.props.showError);
            });
        } else {
          ServicersApi.add(this.state)
            .then(
              servicer => {
                this.props.addServicer(servicer);
                this.props.onCreated(servicer);
                this.props.showMessage(
                  'The new servicer has been added successfully.'
                );
                this.props.onCancel();
              },
              error => {
                this.setState({ busy: false }, this.props.showError);
              }
            )
            .catch(error => {
              this.setState({ busy: false }, this.props.showError);
            });
        }
      });
    }
  };
  render() {
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          {this.props.edit ? 'Edit' : 'Add New'} Loan Servicer
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              Use the form below to add a new Loan Servicer. Make sure all the
              information you enter is correct, since it will be used to mail
              the application forms to this servicer.
            </p>

            <div className="row">
              <div className="col-12">
                <div className="form-group nice">
                  <label>Servicer Name:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Name of the Loan Servicer"
                    className="form-control"
                    value={this.state.name}
                    onChange={this.handleInputChange}
                    name="name"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Address Line 1:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Servicer Address Line 1"
                    className="form-control"
                    value={this.state.address1}
                    onChange={this.handleInputChange}
                    name="address1"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Address Line 2:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Servicer Address Line 2"
                    className="form-control"
                    value={this.state.address2}
                    onChange={this.handleInputChange}
                    name="address2"
                  />
                </div>
              </div>
              <div className="col-5">
                <div className="form-group nice">
                  <label>City:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="City"
                    className="form-control"
                    value={this.state.city}
                    onChange={this.handleInputChange}
                    name="city"
                  />
                </div>
              </div>
              <div className="col-2">
                <div className="form-group nice">
                  <label>State:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="State"
                    className="form-control"
                    value={this.state.state}
                    onChange={this.handleInputChange}
                    name="state"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group nice">
                  <label>Zip Code:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Zip Code"
                    className="form-control"
                    value={this.state.zip}
                    onChange={this.handleInputChange}
                    name="zip"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Email Address:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Servicer Email Address"
                    className="form-control"
                    value={this.state.email}
                    onChange={this.handleInputChange}
                    name="email"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Phone Number:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Servicer Phone Number"
                    className="form-control"
                    value={this.state.phone}
                    onChange={this.handleInputChange}
                    name="phone"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Fax Number:</label>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    placeholder="Servicer Fax Number"
                    className="form-control"
                    value={this.state.fax}
                    onChange={this.handleInputChange}
                    name="fax"
                  />
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.busy}
            variant="outlined"
            onClick={this.save}
            color="primary"
            autoFocus
          >
            {this.props.mode === 'edit' ? 'Update Servicer' : 'Save Servicer'}
          </Button>
          <Button
            disabled={this.state.busy}
            onClick={this.props.onCancel}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default connect(
  null,
  {
    showError,
    showMessage,
    addServicer,
    updateServicer
  }
)(Servicer);
